import { CandidateData } from '../../../../types/candidates';

const filterByLanguages = (
  singleCandidate: CandidateData,
  searchedLanguage: string
) => {
  return !!(
    searchedLanguage &&
    singleCandidate?.CandidateLanguages &&
    !!singleCandidate?.CandidateLanguages?.find((candidateLanguage) => {
      return (
        candidateLanguage.LanguageName &&
        candidateLanguage.LanguageName.toLowerCase() ===
          searchedLanguage.toLowerCase()
      );
    })
  );
};

export default filterByLanguages;
